import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-bir-supplier-class-range',
  templateUrl: './bir-supplier-class-range.component.html',
  standalone: false
})
export class BirSupplierClassRangeComponent {
  @Input() type: 'both' | 'customer' | 'supplier' = 'both';

  @Input() from: any = null;
  @Input() to: any = null;

  @Output() readonly fromChange = new EventEmitter();
  @Output() readonly toChange = new EventEmitter();

  constructor() {}
}
